<template>
  <div v-if="agreement" class="agreement-badge">
    <v-chip
      small
      color="primary"
      text-color="white"
      class="badge-chip"
    >
      <v-icon left x-small>mdi-link-variant</v-icon>
      {{ $t('scorecard_has_agreement') }}
    </v-chip>

    <div v-if="showDetails" class="badge-details mt-2">
      <div class="detail-row">
        <strong>{{ agreement.name }}</strong>
      </div>
      <div class="detail-row text-caption grey--text">
        Tipo: {{ getAgreementTypeName(agreement.agreement_type) }}
      </div>
      <div class="detail-row text-caption grey--text">
        Coordinador: {{ agreement.coordinator_name }}
      </div>
      <div class="detail-row text-caption">
        <a :href="`tel:${agreement.coordinator_phone}`" class="link">
          {{ agreement.coordinator_phone }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AgreementBadge',
  props: {
    agreement: {
      type: Object,
      default: null
    },
    showDetails: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('courseAgreements', ['getAgreementTypeName'])
  }
}
</script>

<style scoped lang="scss">
.agreement-badge {
  display: inline-block;
}

.badge-chip {
  cursor: pointer;
}

.badge-details {
  background: #f5f5f5;
  padding: 12px;
  border-radius: 4px;
  max-width: 300px;
}

.detail-row {
  margin-bottom: 6px;
  font-size: 13px;

  &:last-child {
    margin-bottom: 0;
  }

  .link {
    color: #0066cc;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
